import { USERNAME_MAX_LENGTH, USERNAME_MIN_LENGTH } from "@fortress/shared";

// Username input handling shared by the first-login picker and the Account
// tab's rename form, so both enforce the same characters the same way.

/** Keep only the characters a username may contain (lowercase letters,
 * digits, `.` and `-`) as the user types. `validateUsername` enforces the
 * separator rules and length on submit, and the server re-validates. */
export function sanitizeUsernameInput(raw: string): string {
  return raw.toLowerCase().replace(/[^a-z0-9.-]/g, "");
}

/** Human-readable message for a `validateUsername` / server error code. */
export function usernameErrorMessage(code: string): string {
  switch (code) {
    case "empty":
      return "Enter a username.";
    case "too_short":
      return `Use at least ${USERNAME_MIN_LENGTH} characters.`;
    case "too_long":
      return `Use at most ${USERNAME_MAX_LENGTH} characters.`;
    case "invalid":
      return "Use lowercase letters and numbers. . and - are allowed between characters, not at the ends, and not repeated.";
    case "taken":
      return "That username is taken. Try another.";
    default:
      return "Couldn't save that username. Try again.";
  }
}
